'use strict';

var skeleton = require('./unlimitailSkeleton');

$(() => {
    var UnlimitailTracking = {
        config: {
            trackingClass: 'js-unlimitail-track',
            idAttribute: 'data-unlimitail-id',
            configSelector: '.js-unlimitail-config',
            endpointAttribute: 'data-tracking-url',
            slotSelector: '.js-unlimitail-slot',
            showUrlAttribute: 'data-unlimitail-show-url',
            trackingEndpoint: '',
            debug: true
        },

        trackedImpressions: {},
        impressionCandidates: {},
        recentTrackedEvents: {},
        initialized: false,
        observer: null,

        init: function (options) {
            if (options) {
                $.extend(this.config, options);
            }

            this.ensureTrackingEndpoint();

            if (this.initialized) {
                this.refresh();
                return;
            }

            this.initialized = true;
            this.setupClickTracking();
            this.setupImpressionTracking();
            this.setupDomObserver();
            this.refresh();
        },


        ensureTrackingEndpoint: function () {
            if (this.config.trackingEndpoint) {
                return this.config.trackingEndpoint;
            }

            this.config.trackingEndpoint = this.getTrackingEndpointFromHtml();
            return this.config.trackingEndpoint;
        },


        getTrackingEndpointFromHtml: function () {
            var $configElement = $(this.config.configSelector).first();

            if (!$configElement.length) {
                return '';
            }

            var trackingEndpoint = $configElement.attr(
                this.config.endpointAttribute
            );

            if (!trackingEndpoint) {
                return '';
            }

            return trackingEndpoint;
        },


        setupClickTracking: function () {
            var self = this;
            var selector = '.' + this.config.trackingClass;


            $(document).off('click.unlimitailTracking', selector).on('click.unlimitailTracking', selector,
                function (event) {
                    var closestMatch = $(event.target).closest(selector).get(0);
                    if (closestMatch !== event.currentTarget) {
                        return;
                    }

                    var adId = self.getTrackingId($(this));

                    if (!adId) {
                        return;
                    }

                    self.trackEvent('C', adId);
                }
            );
        },

        setupImpressionTracking: function () {
            var self = this;

            setTimeout(function () {
                self.checkVisibleElements();
            }, 100);

            setInterval(function () {
                self.checkVisibleElements();
            }, 300);

            $(window).off('scroll.unlimitailTracking').on('scroll.unlimitailTracking',
                this.debounce(function () {
                    self.checkVisibleElements();
                }, 100)
            );

            $(window).off('resize.unlimitailTracking').on('resize.unlimitailTracking',
                this.debounce(function () {
                    self.checkVisibleElements();
                }, 100)
            );
        },

        checkVisibleElements: function () {
            var self = this;
            var selector = '.' + this.config.trackingClass;
            var $elements = $(selector);
            var now = Date.now();

            $elements.each(function (index) {
                var $element = $(this);
                var adId = self.getTrackingId($element);
                var impressionKey = self.getImpressionKey($element, adId, index);

                if (!adId || self.trackedImpressions[impressionKey]) {
                    return;
                }

                if (self.isElementInViewport($element, 0.5)) {
                    if (!self.impressionCandidates[impressionKey]) {
                        self.impressionCandidates[impressionKey] = now;
                        return;
                    }

                    if ((now - self.impressionCandidates[impressionKey]) < 1000) {
                        return;
                    }

                    self.trackedImpressions[impressionKey] = true;
                    delete self.impressionCandidates[impressionKey];
                    self.trackEvent('I', adId);
                } else {
                    delete self.impressionCandidates[impressionKey];
                }
            });
        },

        getTrackingId: function ($element) {
            var adId = $.trim($element.attr(this.config.idAttribute) || '');

            if (!adId || adId === 'null' || adId === 'undefined') {
                return '';
            }

            return adId;
        },

        getImpressionKey: function ($element, adId, index) {
            var moduleId = $element.attr('data-module-id') || '';
            var position = $element.attr('data-location-number') || String(index);

            return [String(adId || ''), moduleId, position].join(':');
        },

        isElementInViewport: function ($element, minVisibleRatio) {
            if (!$element.length || !$element.is(':visible')) {
                return false;
            }

            var element = $element.get(0);
            var rect = element.getBoundingClientRect();
            var requiredRatio = typeof minVisibleRatio === 'number' ? minVisibleRatio : 0;

            var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

            var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
            var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
            var visibleArea = visibleWidth * visibleHeight;
            var totalArea = Math.max(0, rect.width) * Math.max(0, rect.height);

            if (!totalArea) {
                return false;
            }

            return (visibleArea / totalArea) >= requiredRatio;
        },

        trackEvent: function (type, adId) {
            var eventKey = String(type) + ':' + String(adId);
            var now = Date.now();
            var previousTimestamp = this.recentTrackedEvents[eventKey];

            if (previousTimestamp && (now - previousTimestamp) < 500) {
                return;
            }

            this.recentTrackedEvents[eventKey] = now;

            if (!this.ensureTrackingEndpoint()) {
                return;
            }

            $.ajax({
                url: this.config.trackingEndpoint,
                type: 'GET',
                data: {
                    type: type,
                    citrusAdId: adId
                },

                success: function (response) {
                    //Intentionally left blank
                },

                error: function () {
                    // Handle error if needed
                }
            });
        },

        loadAjaxSlots: function () {
            var self = this;
            var $slots = $(this.config.slotSelector);

            $slots.each(function () {
                var $slot = $(this);
                var alreadyLoaded = $slot.attr('data-unlimitail-loaded') === 'true';
                var isLoading = $slot.attr('data-unlimitail-loading') === 'true';
                var showUrl = $slot.attr(self.config.showUrlAttribute);

                if (alreadyLoaded || isLoading || !showUrl) {
                    return;
                }

                $slot.attr('data-unlimitail-loading', 'true');

                $.ajax({
                    url: showUrl,
                    type: 'GET',
                    success: function (html) {
                        skeleton.replace($slot, html);
                        $slot.attr('data-unlimitail-loaded', 'true');
                        $slot.removeAttr('data-unlimitail-loading');
                        $('body').trigger('reinitSlick');
                        self.refresh();
                    },
                    error: function () {
                        $slot.find('.cc-unlimitail-seo').remove();
                        $slot.attr('data-unlimitail-loaded', 'true');
                        $slot.removeAttr('data-unlimitail-loading');
                        self.updateComponentTitles();
                    }
                });
            });
        },

        hasRenderableContent: function ($component) {
            var self = this;
            var $slots = $component.find(this.config.slotSelector);

            if ($slots.length) {
                var hasLoadedContent = false;

                $slots.each(function () {
                    var $slot = $(this);
                    var isLoading = $slot.attr('data-unlimitail-loading') === 'true';
                    var isLoaded = $slot.attr('data-unlimitail-loaded') === 'true';

                    if (isLoading || !isLoaded) {
                        return;
                    }

                    if (self.hasTrackableItems($slot)) {
                        hasLoadedContent = true;
                    }
                });

                return hasLoadedContent;
            }

            var $content = $component.find('.js-unlimitail-content').first();

            if (!$content.length) {
                return false;
            }

            return this.hasTrackableItems($content);
        },

        hasTrackableItems: function ($container) {
            if (!$container || !$container.length) {
                return false;
            }

            var trackSelector = '.' + this.config.trackingClass;
            return $container.find(trackSelector).length > 0;
        },

        hasInlineTagBadge: function ($component) {
            if (!$component || !$component.length) {
                return false;
            }

            return $component.find('.js-unlimitail-content .cc-unlimitail__tag').length > 0;
        },

        moveHeaderIntoLogos: function () {
            $('.js-unlimitail-component').each(function () {
                var $component = $(this);
                var $outerContainer = $component.children('.container').first();
                var $header = $outerContainer.children('.cc-unlimitail__title-wrp').first();
                var $logosContainer = $component.find('.js-unlimitail-content .cc-em-logos > .container').first();

                if (!$outerContainer.length || !$header.length || !$logosContainer.length) {
                    return;
                }

                if ($logosContainer.children('.cc-unlimitail__title-wrp').length === 0) {
                    $logosContainer.prepend($header);
                }

                if ($outerContainer.children().length === 0) {
                    $outerContainer.attr('hidden', 'hidden');
                }
            });
        },

        updateComponentTitles: function () {
            var self = this;

            $('.js-unlimitail-component').each(function () {
                var $component = $(this);
                var $title = $component.find('.js-unlimitail-title').first();
                var $tagLabel = $component.find('.cc-unlimitail__tagLabel').first();
                var hasContent = self.hasRenderableContent($component);
                var hasInlineTagBadge = self.hasInlineTagBadge($component);
                var $headerSkeleton = $component.find('.js-unlimitail-header-skeleton');

                if ($headerSkeleton.length && $component.find('.js-unlimitail-slot[data-unlimitail-loaded="false"]').length) {
                    return;
                }
                $headerSkeleton.removeClass('cc-unlimitail-seo js-unlimitail-header-skeleton');

                if (hasContent) {
                    $title.removeAttr('hidden');
                } else {
                    $title.attr('hidden', 'hidden');
                }

                if ($tagLabel.length) {
                    if (hasContent && !hasInlineTagBadge) {
                        $tagLabel.removeAttr('hidden');
                    } else {
                        $tagLabel.attr('hidden', 'hidden');
                    }
                }
            });
        },

        refresh: function () {
            var endpoint = this.getTrackingEndpointFromHtml();

            if (endpoint) {
                this.config.trackingEndpoint = endpoint;
            }

            this.loadAjaxSlots();
            this.moveHeaderIntoLogos();
            this.updateComponentTitles();
            this.checkVisibleElements();
        },

        setupDomObserver: function () {
            var self = this;

            if (this.observer || !window.MutationObserver) {
                return;
            }

            this.observer = new MutationObserver(this.debounce(function () {
                self.refresh();
            }, 100));

            this.observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        },


        debounce: function (callback, delay) {
            var timeoutId;

            return function () {
                var context = this;
                var args = arguments;

                clearTimeout(timeoutId);

                timeoutId = setTimeout(function () {
                    callback.apply(context, args);
                }, delay);
            };
        }
    };

    window.UnlimitailTracking = UnlimitailTracking;

    $(function () {
        UnlimitailTracking.init();
    });
});